export function Logo({ size = 'md' }: { size?: 'sm' | 'md' }) {
  return (
    <span className="logo-mark">
      <span className="logo-basket" />
      <span style={{ fontSize: size === 'sm' ? 16 : 18 }}>Stalvi</span>
    </span>
  );
}
